export * from './integrator-utils/get-pn18-from-url.js';
export * from './integrator-utils/remove-preselection-from-search-params.js';
export * from './integrator-utils/storage.js';
export function defineSelectedVehicleService(options) {
    const { marketId, masterPn18 } = options;
    return {
        id: `selected-vehicle-service`,
        create: () => {
            const listeners = new Set();
            let selectedVehicle;
            return {
                '1.0.0': () => {
                    return {
                        featureService: {
                            masterPn18: (masterPn18 !== null && masterPn18 !== void 0 ? masterPn18 : marketId === `gb`)
                                ? `HX1ETD3B62EU010418`
                                : `HX1ETD3A61EU010417`,
                            getSelectedVehicle: () => selectedVehicle,
                            setSelectedVehicle: (vehicle) => {
                                selectedVehicle = vehicle;
                                for (const listener of listeners) {
                                    listener(selectedVehicle);
                                }
                            },
                            subscribe: (listener) => {
                                listeners.add(listener);
                                return () => listeners.delete(listener);
                            },
                        },
                    };
                },
            };
        },
    };
}
//# sourceMappingURL=index.js.map